import React from "react";
import object from "../Terms/temp"
import {Link} from "react-router-dom";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {compose} from "redux";
import {Col, Space, Row, Table, Input, Button, Tag, Popconfirm} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import Item from "./Item";
import Highlighter from 'react-highlight-words';
import Navbar from "../Layout/Navbar";
import {deleteItem} from "../../Store/Actions/item";
const { Column } = Table;

class Items extends React.Component {

    state = {
        visible: false,
        item: null,
        searchText: '',
        searchedColumn: '',
    };

    showDrawer = item => {
        this.setState({
            visible: true,
            item: item
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
            item: null
        });
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };


    onDelete = (item) => {
        deleteItem(item.id, res => {

        })
    }

    render() {
        const { itemsString, companiesString, categoriesString, persString, items, categories, companies, pers } = this.props;
        const { item, visible } = this.state;

        return (
            <div>
                <div>
                    <div>
                        <Row className={"uk-width-1-1"}>
                            <Col span={20}>
                                <div>
                                    <h3 className="uk-h3 uk-margin-remove">
                                        Items
                                    </h3>
                                    <p className="uk-text-small uk-margin-remove">
                                        { items.length} items | { categories.length} categories
                                    </p>
                                </div>
                            </Col>
                            <Col span={4}>
                                <div className="uk-text-right">
                                    <Button onClick={() => this.showDrawer(null)} type="primary">
                                        New item
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Item pers={pers} companies={companies} categories={categories} onClose={this.onClose} item={item} visible={visible} />

                    <div>
                        <div className="uk-text-center">
                            <p>
                                { persString }
                            </p>
                            <p>
                                { categoriesString }
                            </p>
                            <p>
                                { companiesString }
                            </p>
                            <p>
                                { itemsString }
                            </p>
                            {/*<Table dataSource={items}>*/}
                            {/*    <Column width="10%" title="Image" dataIndex="image" key="image" render={(image) => (*/}
                            {/*        <img className="uk-border-rounded" src={image} />*/}
                            {/*    )} />*/}
                            {/*    <Column width="25%" title="Name" dataIndex="name" key="name" {...this.getColumnSearchProps('name')} />*/}
                            {/*    <Column width="20%" title="Category" dataIndex="category" key="category" filters={categories} onFilter={(value, record) => record.category===value} />*/}
                            {/*    <Column width="15%"*/}
                            {/*            title="Price"*/}
                            {/*            dataIndex="price"*/}
                            {/*            key="price"*/}
                            {/*            sorter={(a, b) => a.sum - b.sum}*/}
                            {/*            sortDirections={['descend', 'ascend']}*/}
                            {/*            {...this.getColumnSearchProps('price')}*/}
                            {/*            render={(price) => (*/}
                            {/*                <div>*/}
                            {/*                    { price ? `${parseInt(price.sum / price.count)}₸` : null }  { price.per ? ` /  ${price.per}` : null}*/}
                            {/*                </div>*/}
                            {/*            )} />*/}
                            {/*    />*/}
                            {/*    <Column width="15%" title="Producer" dataIndex="company" key="company" {...this.getColumnSearchProps('company')} />*/}
                            {/*    <Column*/}
                            {/*        width="15%"*/}
                            {/*        title="Actions"*/}
                            {/*        render={(item) => (*/}
                            {/*            <div>*/}
                            {/*                <Space>*/}
                            {/*                    <Button onClick={() => this.showDrawer(item)} className="color-orange" size="small" type="default">*/}
                            {/*                        Edit*/}
                            {/*                    </Button>*/}
                            {/*                    <Popconfirm*/}
                            {/*                        title="Are you sure delete this task?"*/}
                            {/*                        onConfirm={() => this.onDelete(item)}*/}
                            {/*                        okText="Delete"*/}
                            {/*                        cancelText="Cancel"*/}
                            {/*                        dataIndex={"id"}*/}
                            {/*                    >*/}
                            {/*                        <Button size="small" type="default" className="color-red">*/}
                            {/*                            Delete*/}
                            {/*                        </Button>*/}
                            {/*                    </Popconfirm>*/}
                            {/*                </Space>*/}
                            {/*            </div>*/}
                            {/*        )} />*/}

                            {/*</Table>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {

    let items = [];
    let categories = [];
    let companies = [];
    let pers = [];
    if(state.firestore.ordered.items) {
        items = state.firestore.ordered.items.map(item => {
            if(!categories.includes(item.category)){
                categories.push(item.category);
            }
            if(item.company && !companies.includes(item.company)){
                companies.push(item.company);
            }
            if(item.price && item.price.per && !pers.includes(item.price.per)){
                pers.push(item.price.per);
            }
            return {
                key: item.id,
                ...item
            }
        })
    }

    // console.log(JSON.stringify(pers))
    // console.log(JSON.stringify(categories))
    // console.log(JSON.stringify(companies))
    // console.log(JSON.stringify(items))

    return {
        persString: JSON.stringify(pers),
        categoriesString: JSON.stringify(categories),
        companiesString: JSON.stringify(companies),
        itemsString: JSON.stringify(items),
        auth: state.firebase.auth,
        items: items,
        categories: categories.map(category => {
            return {
                text: category,
                value: category
            }
        }),
        companies: companies.map(company => {
            return {
                text: company,
                value: company
            }
        }),
        pers: pers.map(per => {
            return {
                text: per,
                value: per
            }
        })
    }
}

const enhance = compose(
    firestoreConnect([
        // { collection: "items"  }
    ]),
    connect(mapStateToProps)
);
export default enhance(Items);



// WEBPACK FOOTER //
// ./src/Components/Items/index.js